<div class="relative h-[100%]" [@pageLoad]="pageLoadState">
  <div class="gap-[40px] flex flex-col shrink-0 justify-around items-center pl-[64px] pr-[64px] pt-[40px] pb-[40px] bg-[#f8fafdff] w-[100%] h-[100%]  relative">
    <div class="gap-[40px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch grow basis-0  ">
      <div class="gap-[40px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch">
       
        <span class="w-[100%] shrink-0 justify-start items-start self-stretch text-[#111215ff] text-center font-bold font-['archivo'] text-[24px] leading-[26px]">
          Would you Like to Join an Activity Today?
        </span>
        
        <div class="gap-[24px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch grow basis-0">
          <!-- Category Tabs -->
          <div class="flex flex-row w-[100%] shrink-0 justify-center items-start self-stretch pl-[8px] pr-[8px] pt-[12px] pb-[12px] border-t-[2px] border-b-[2px] border-[#E5E7EB]">
            <div class="flex flex-row shrink-0 justify-start items-center gap-[8px]">
              <NiButton
                *ngFor="let category of categories"
                [variant]="selectedCategory === category.id ? 'contained' : 'text'"
                color="primary"
                size="[18px]"
                [label]="category.label"
                (onClick)="selectCategory(category.id)"
                [px]="'[16px]'"
                [py]="'[12px]'"
                [rounded]="'full'"
                [disabled]="false"
                [bg]="selectedCategory === category.id ? '[#111215ff]' : 'transparent'"
                [textColor]="selectedCategory === category.id ? '#F7FAFC' : '#444955'"
                [styleClass]="
                  selectedCategory === category.id
                    ? 'flex flex-row items-center gap-[8px] rounded-[8px] bg-[#111215ff] text-white font-bold font-[\'archivo\'] text-[18px] leading-[23px] px-[16px] py-[8px]'
                    : 'flex flex-row items-center gap-[8px] rounded-[8px] text-[#444955] font-bold font-[\'archivo\'] text-[18px] leading-[23px] px-[16px] py-[8px] hover:bg-[#f2f5f7]'">
              </NiButton>
            </div>
          </div>

          <!-- Activity Cards Grid -->
          <div 
            class="gap-[28px] flex flex-row w-[1046px] content-center flex-wrap shrink-0 justify-center items-start grow basis-0 relative min-h-[400px]">
            <!-- Loading State -->
            <div 
              *ngIf="isLoading && filteredActivities.length === 0" 
              class="w-[100%] flex flex-col justify-center items-center gap-[32px]">
              <!-- Loading Text with Pulse Animation -->
              <div class="flex flex-row items-center gap-[12px] animate-fade-in-down">
                <span class="text-[#111215ff] font-['archivo'] font-medium text-[16px] opacity-70">Loading activities</span>
                <div class="flex gap-1 items-center">
                  <span class="w-1.5 h-1.5 rounded-full bg-[#111215ff] opacity-30 animate-dot-pulse"></span>
                  <span class="w-1.5 h-1.5 rounded-full bg-[#111215ff] opacity-30 animate-dot-pulse [animation-delay:0.2s]"></span>
                  <span class="w-1.5 h-1.5 rounded-full bg-[#111215ff] opacity-30 animate-dot-pulse [animation-delay:0.4s]"></span>
                </div>
              </div>
              
              <!-- Skeleton Cards -->
              <div class="w-[100%] flex flex-row flex-wrap justify-center items-start gap-[28px]">
                <!-- Skeleton Card 1 -->
                <div class="relative w-[240px] h-[160px] rounded-2xl overflow-hidden bg-gray-100 shadow-sm animate-skeleton-fade opacity-0">
                  <div class="absolute inset-0 w-full h-full bg-[length:200%_100%] animate-shimmer" style="background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 20%, #e5e7eb 40%, #e5e7eb 100%);"></div>
                  <div class="absolute bottom-0 left-0 right-0 h-[44px] animate-pulse" style="background: linear-gradient(to top, rgba(17, 18, 21, 0.15) 10%, rgba(17, 18, 21, 0.15) 60%, rgba(17, 18, 21, 0) 100%);"></div>
                  <div class="absolute bottom-3 left-1/2 -translate-x-1/2 w-[60%] h-5 rounded bg-[length:200%_100%] animate-shimmer [animation-delay:0.3s]" style="background: linear-gradient(90deg, #d1d5db 0%, #e5e7eb 20%, #d1d5db 40%, #d1d5db 100%);"></div>
                  <div class="absolute top-2 right-2 w-6 h-6 rounded-full bg-white/40 border border-gray-200/60 animate-pulse"></div>
                </div>
                <!-- Skeleton Card 2 -->
                <div class="relative w-[240px] h-[160px] rounded-2xl overflow-hidden bg-gray-100 shadow-sm animate-skeleton-fade opacity-0 [animation-delay:0.1s]">
                  <div class="absolute inset-0 w-full h-full bg-[length:200%_100%] animate-shimmer" style="background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 20%, #e5e7eb 40%, #e5e7eb 100%);"></div>
                  <div class="absolute bottom-0 left-0 right-0 h-[44px] animate-pulse" style="background: linear-gradient(to top, rgba(17, 18, 21, 0.15) 10%, rgba(17, 18, 21, 0.15) 60%, rgba(17, 18, 21, 0) 100%);"></div>
                  <div class="absolute bottom-3 left-1/2 -translate-x-1/2 w-[60%] h-5 rounded bg-[length:200%_100%] animate-shimmer [animation-delay:0.3s]" style="background: linear-gradient(90deg, #d1d5db 0%, #e5e7eb 20%, #d1d5db 40%, #d1d5db 100%);"></div>
                  <div class="absolute top-2 right-2 w-6 h-6 rounded-full bg-white/40 border border-gray-200/60 animate-pulse"></div>
                </div>
                <!-- Skeleton Card 3 -->
                <div class="relative w-[240px] h-[160px] rounded-2xl overflow-hidden bg-gray-100 shadow-sm animate-skeleton-fade opacity-0 [animation-delay:0.2s]">
                  <div class="absolute inset-0 w-full h-full bg-[length:200%_100%] animate-shimmer" style="background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 20%, #e5e7eb 40%, #e5e7eb 100%);"></div>
                  <div class="absolute bottom-0 left-0 right-0 h-[44px] animate-pulse" style="background: linear-gradient(to top, rgba(17, 18, 21, 0.15) 10%, rgba(17, 18, 21, 0.15) 60%, rgba(17, 18, 21, 0) 100%);"></div>
                  <div class="absolute bottom-3 left-1/2 -translate-x-1/2 w-[60%] h-5 rounded bg-[length:200%_100%] animate-shimmer [animation-delay:0.3s]" style="background: linear-gradient(90deg, #d1d5db 0%, #e5e7eb 20%, #d1d5db 40%, #d1d5db 100%);"></div>
                  <div class="absolute top-2 right-2 w-6 h-6 rounded-full bg-white/40 border border-gray-200/60 animate-pulse"></div>
                </div>
                <!-- Skeleton Card 4 -->
                <div class="relative w-[240px] h-[160px] rounded-2xl overflow-hidden bg-gray-100 shadow-sm animate-skeleton-fade opacity-0 [animation-delay:0.3s]">
                  <div class="absolute inset-0 w-full h-full bg-[length:200%_100%] animate-shimmer" style="background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 20%, #e5e7eb 40%, #e5e7eb 100%);"></div>
                  <div class="absolute bottom-0 left-0 right-0 h-[44px] animate-pulse" style="background: linear-gradient(to top, rgba(17, 18, 21, 0.15) 10%, rgba(17, 18, 21, 0.15) 60%, rgba(17, 18, 21, 0) 100%);"></div>
                  <div class="absolute bottom-3 left-1/2 -translate-x-1/2 w-[60%] h-5 rounded bg-[length:200%_100%] animate-shimmer [animation-delay:0.3s]" style="background: linear-gradient(90deg, #d1d5db 0%, #e5e7eb 20%, #d1d5db 40%, #d1d5db 100%);"></div>
                  <div class="absolute top-2 right-2 w-6 h-6 rounded-full bg-white/40 border border-gray-200/60 animate-pulse"></div>
                </div>
              </div>
            </div>
            
            <!-- Error State -->
            <div 
              *ngIf="error && !isLoading" 
              class="w-[100%] flex flex-col justify-center items-center py-[40px] gap-[16px]">
              <span class="text-[#ef4444] font-['archivo'] text-[18px] text-center">{{ error }}</span>
              <NiButton
                variant="contained"
                color="primary"
                size="[18px]"
                label="Retry"
                [px]="'[24px]'"
                [py]="'[12px]'"
                [rounded]="'[999px]'"
                bg="[#f26f24ff]"
                textColor="#ffffff"
                (onClick)="loadActivities()"
                [styleClass]="'flex flex-row items-center gap-[8px] rounded-[999px] bg-[#f26f24ff] text-white font-bold font-[\'archivo\'] text-[16px] leading-[20px] px-[24px] py-[12px]'">
              </NiButton>
            </div>
            
            <!-- Empty State -->
            <div 
              *ngIf="!isLoading && !error && filteredActivities.length === 0" 
              class="w-[100%] flex justify-center items-center py-[40px]">
              <span class="text-[#111215ff] font-['archivo'] text-[18px]">No activities available for this category.</span>
            </div>
            
            <!-- Activity Cards -->
            <div
              *ngFor="let activity of filteredActivities; trackBy: trackByActivityId; let i = index"
              class="inline-block opacity-0 animate-activity-card will-change-transform [animation-timing-function:cubic-bezier(0.4,0.0,0.2,1)] group"
              [attr.data-category]="selectedCategory"
              [style.animation-delay]="(i * 0.05) + 's'">
              <div
                (click)="toggleActivity(activity)"
                (keydown)="handleKeyDown($event, activity)"
                class="relative w-[240px] h-[160px] shrink-0 rounded-[16px] cursor-pointer overflow-hidden bg-[#ffffff] transition-all duration-200 ease-out hover:-translate-y-[3px] active:translate-y-0 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#5BA5F54D]"
                [ngClass]="{
                  'border-[4px] border-[#4caf50ff] shadow-[0_12px_20px_rgba(76,175,80,0.25)] hover:shadow-[0_16px_24px_rgba(76,175,80,0.35)]': isActivitySelected(activity.id),
                  'border-[1px] border-[#E5E7EB] hover:border-[#E5E7EB]/50 hover:shadow-[0_12px_18px_rgba(15,23,42,0.14)]': !isActivitySelected(activity.id)
                }">
              <!-- Activity Image - Full Card -->
              <div
                class="absolute inset-0 w-[100%] h-[100%] opacity-0 transition-none backface-hidden transform-gpu -webkit-transform-gpu"
                [class.opacity-100]="imagesLoaded[activity.id]"
                [class.transition-opacity]="imagesLoaded[activity.id]"
                [class.duration-50]="imagesLoaded[activity.id]"
                [class.linear]="imagesLoaded[activity.id]"
                [style.background-image]="activity.image ? ('url(' + activity.image + ')') : 'none'"
                style="background-repeat: no-repeat; background-size: cover; background-position: center; -webkit-font-smoothing: antialiased;">
              </div>

              <!-- Placeholder when image is missing or failed to load -->
              <div
                *ngIf="!imagesLoaded[activity.id]"
                class="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-[#E8EEF5] to-[#D0D5DD]"
                aria-hidden="true">
                <span class="text-[#667085] font-['archivo'] font-semibold text-[16px] px-4 text-center">
                  {{ activity.name }}
                </span>
              </div>
              
              <!-- Animated Vector Elements Based on Activity Type -->
              <div class="absolute inset-0 pointer-events-none overflow-hidden opacity-60 transition-opacity duration-300 group-hover:opacity-100">
                <!-- Chess - Floating Pieces -->
                <div *ngIf="activity.name.toLowerCase().includes('chess')" class="absolute inset-0">
                  <div class="absolute top-[10%] left-[15%] text-2xl text-white/90 [text-shadow:0_0_10px_rgba(255,255,255,0.3)] animate-float-chess">♟</div>
                  <div class="absolute top-[30%] right-[20%] text-xl text-white/90 [text-shadow:0_0_10px_rgba(255,255,255,0.3)] animate-float-chess [animation-delay:1.3s]">♞</div>
                  <div class="absolute bottom-[50%] left-[10%] text-[22px] text-white/90 [text-shadow:0_0_10px_rgba(255,255,255,0.3)] animate-float-chess [animation-delay:2.6s]">♜</div>
                </div>
                
                <!-- Carrom - Moving Striker -->
                <div *ngIf="activity.name.toLowerCase().includes('carrom')" class="absolute inset-0">
                  <div class="absolute top-[20%] left-[10%] w-4 h-4 rounded-full  animate-carrom-move" style="background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.9), rgba(200, 200, 200, 0.7));"></div>
                  <div class="absolute bottom-[30%] right-[15%] w-4 h-4 rounded-full shadow-[0_2px_8px_rgba(0,0,0,0.4)] animate-carrom-move [animation-delay:1.5s]" style="background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.9), rgba(200, 200, 200, 0.7));"></div>
                  <div class="absolute top-1/2 left-1/2 w-0.5 h-10 bg-gradient-to-b from-transparent via-white/30 to-transparent -translate-x-1/2 -translate-y-1/2 rotate-45 animate-carrom-line"></div>
                </div>
                
                <!-- Memory/Brain - Puzzle Pieces -->
                <div *ngIf="activity.name.toLowerCase().includes('memory') || activity.name.toLowerCase().includes('brain') || activity.name.toLowerCase().includes('teaser')" class="absolute inset-0">
                  <div class="absolute top-[15%] left-[20%] text-xl text-[rgba(255,200,100,0.8)] [text-shadow:0_0_10px_rgba(255,200,100,0.6)] animate-memory-spark">✦</div>
                  <div class="absolute top-[25%] right-[15%] text-base text-[rgba(255,200,100,0.8)] [text-shadow:0_0_10px_rgba(255,200,100,0.6)] animate-memory-spark [animation-delay:0.75s]">✧</div>
                  <div class="absolute bottom-[45%] left-[15%] text-lg text-[rgba(255,200,100,0.8)] [text-shadow:0_0_10px_rgba(255,200,100,0.6)] animate-memory-spark [animation-delay:1.5s]">★</div>
                  <div class="absolute top-[40%] right-[25%] text-[22px] text-[rgba(255,200,100,0.8)] [text-shadow:0_0_10px_rgba(255,200,100,0.6)] animate-memory-spark [animation-delay:2.25s]">✦</div>
                </div>
                
                <!-- Physical Exercise - Advanced Motion & Energy Effects -->
                <div *ngIf="activity.name.toLowerCase().includes('physical') || activity.name.toLowerCase().includes('exercise')" class="absolute inset-0">
                  <!-- ECG Heartbeat Line -->
                  <div class="absolute top-[10%] left-0 right-0 h-10 overflow-hidden opacity-70">
                    <svg class="w-full h-full animate-ecg-pulse" viewBox="0 0 200 60" preserveAspectRatio="none">
                      <path class="[stroke-dasharray:200] [stroke-dashoffset:200] animate-ecg-draw" 
                            style="filter: drop-shadow(0 0 4px rgba(255, 80, 80, 0.6));"
                            d="M0,30 L40,30 L45,20 L50,40 L55,10 L60,50 L65,30 L200,30" 
                            stroke="rgba(255, 80, 80, 0.8)" stroke-width="2" fill="none"/>
                    </svg>
                  </div>
                  
                  <!-- Speed Lines with Gradient -->
                  <div class="absolute top-[25%] -left-[30px] w-[70px] h-[3px] rounded-sm shadow-[0_0_6px_rgba(100,200,255,0.4)] animate-physical-wave" style="background: linear-gradient(90deg, transparent, rgba(100, 200, 255, 0.7), rgba(255, 150, 100, 0.5), transparent);"></div>
                  <div class="absolute top-[40%] -left-[30px] w-[55px] h-[3px] rounded-sm shadow-[0_0_6px_rgba(100,200,255,0.4)] animate-physical-wave [animation-delay:0.3s]" style="background: linear-gradient(90deg, transparent, rgba(100, 200, 255, 0.7), rgba(255, 150, 100, 0.5), transparent);"></div>
                  <div class="absolute top-[55%] -left-[30px] w-[65px] h-[3px] rounded-sm shadow-[0_0_6px_rgba(100,200,255,0.4)] animate-physical-wave [animation-delay:0.6s]" style="background: linear-gradient(90deg, transparent, rgba(100, 200, 255, 0.7), rgba(255, 150, 100, 0.5), transparent);"></div>
                  <div class="absolute top-[70%] -left-[30px] w-[50px] h-[3px] rounded-sm shadow-[0_0_6px_rgba(100,200,255,0.4)] animate-physical-wave [animation-delay:0.9s]" style="background: linear-gradient(90deg, transparent, rgba(100, 200, 255, 0.7), rgba(255, 150, 100, 0.5), transparent);"></div>
                  <div class="absolute top-[35%] -left-[30px] w-[60px] h-[3px] rounded-sm shadow-[0_0_6px_rgba(100,200,255,0.4)] animate-physical-wave [animation-delay:0.45s]" style="background: linear-gradient(90deg, transparent, rgba(255, 100, 180, 0.7), rgba(100, 255, 220, 0.6), transparent);"></div>
                  
                  <!-- Multi-Layer Heartbeat Pulse -->
                  <div class="absolute top-[15%] right-[15%] w-6 h-6 border-[3px] border-[rgba(255,80,80,0.8)] rounded-full animate-heartbeat-pulse"></div>
                  <div class="absolute top-[15%] right-[15%] w-6 h-6 border-2 border-[rgba(255,80,80,0.5)] rounded-full animate-heartbeat-pulse [animation-delay:0.75s]"></div>
                  <div class="absolute top-[15%] right-[15%] w-6 h-6 border-2 border-[rgba(100,200,255,0.6)] rounded-full animate-heartbeat-pulse [animation-delay:0.375s]"></div>
                  
                  <!-- Energy Burst Particles -->
                  <div class="absolute top-[30%] left-[20%] text-[10px] text-[rgba(100,220,255,0.9)] [text-shadow:0_0_8px_rgba(100,220,255,0.8)] animate-energy-burst">●</div>
                  <div class="absolute top-[45%] left-[35%] text-[10px] text-[rgba(100,220,255,0.9)] [text-shadow:0_0_8px_rgba(100,220,255,0.8)] animate-energy-burst [animation-delay:0.6s]">●</div>
                  <div class="absolute top-[60%] left-[25%] text-[10px] text-[rgba(100,220,255,0.9)] [text-shadow:0_0_8px_rgba(100,220,255,0.8)] animate-energy-burst [animation-delay:1.2s]">●</div>
                  <div class="absolute top-[35%] right-[30%] text-[10px] text-[rgba(100,220,255,0.9)] [text-shadow:0_0_8px_rgba(100,220,255,0.8)] animate-energy-burst [animation-delay:1.8s]">●</div>
                  <div class="absolute top-[50%] right-[25%] text-xs text-[rgba(100,220,255,0.9)] [text-shadow:0_0_8px_rgba(100,220,255,0.8)] animate-energy-burst [animation-delay:0.5s]">●</div>
                  <div class="absolute top-[25%] left-[40%] text-[8px] text-[rgba(100,220,255,0.9)] [text-shadow:0_0_8px_rgba(100,220,255,0.8)] animate-energy-burst [animation-delay:1.5s]">●</div>
                  
                  <!-- Activity Rings (like Apple Watch) -->
                  <div class="absolute top-1/2 left-1/2 w-[50px] h-[50px] border-[3px] border-transparent border-t-[rgba(255,70,130,0.8)] border-r-[rgba(255,70,130,0.6)] rounded-full -translate-x-1/2 -translate-y-1/2 animate-activity-ring"></div>
                  <div class="absolute top-1/2 left-1/2 w-10 h-10 border-[3px] border-transparent border-t-[rgba(100,220,100,0.8)] border-r-[rgba(100,220,100,0.6)] rounded-full -translate-x-1/2 -translate-y-1/2 animate-activity-ring-reverse"></div>
                  <div class="absolute top-1/2 left-1/2 w-[30px] h-[30px] border-2 border-transparent border-t-[rgba(100,180,255,0.8)] border-r-[rgba(100,180,255,0.6)] rounded-full -translate-x-1/2 -translate-y-1/2 animate-activity-ring"></div>
                  
                 
                  
                  <!-- Running/Motion Trails -->
                  <div class="absolute bottom-[30%] left-[15%] w-10 h-10 rounded-full bg-[radial-gradient(circle,rgba(255,200,100,0.3),transparent)] animate-running-trail"></div>
                  <div class="absolute bottom-[30%] left-[15%] w-10 h-10 rounded-full bg-[radial-gradient(circle,rgba(255,200,100,0.3),transparent)] animate-running-trail [animation-delay:0.5s]"></div>
                  <div class="absolute bottom-[40%] right-[10%] w-[25px] h-[25px] rounded-full bg-[radial-gradient(circle,rgba(255,200,100,0.3),transparent)] animate-running-trail [animation-delay:1.8s]"></div>
                  
                  <!-- Spiral Energy Trail -->
                  <div class="absolute top-1/2 left-1/2 w-[60px] h-[60px] border-2 border-[rgba(100,255,200,0.6)] rounded-full -translate-x-1/2 -translate-y-1/2 animate-spiral-spin"></div>
                  
                  <!-- Power/Lightning Icon -->
                  <div class="absolute top-[60%] right-[20%] text-xl animate-power-flash [filter:drop-shadow(0_0_8px_rgba(255,220,100,0.8))]">⚡</div>
                  
                  <!-- Fitness Icons -->
                </div>
                
                <!-- Music/Karaoke - Sound Waves -->
                <div *ngIf="activity.name.toLowerCase().includes('music') || activity.name.toLowerCase().includes('karaoke')" class="absolute inset-0">
                  <div class="absolute bottom-[10%] left-[20%] text-2xl text-[rgba(255,150,200,1)] [text-shadow:0_2px_12px_rgba(255,150,200,0.9)] animate-music-float font-bold">♪</div>
                  <div class="absolute bottom-[20%] left-1/2 text-[28px] text-[rgba(255,150,200,1)] [text-shadow:0_2px_12px_rgba(255,150,200,0.9)] animate-music-float [animation-delay:1.3s] font-bold">♫</div>
                  <div class="absolute bottom-[15%] right-[20%] text-xl text-[rgba(255,150,200,1)] [text-shadow:0_2px_12px_rgba(255,150,200,0.9)] animate-music-float [animation-delay:2.6s] font-bold">♪</div>
                  <div class="absolute bottom-1/2 left-[40%] w-[4px] h-5 bg-[rgba(255,150,200,0.9)] rounded-sm animate-sound-wave shadow-[0_0_8px_rgba(255,150,200,0.7)]"></div>
                  <div class="absolute bottom-1/2 left-[60%] w-[4px] h-[30px] bg-[rgba(255,150,200,0.9)] rounded-sm animate-sound-wave [animation-delay:0.3s] shadow-[0_0_8px_rgba(255,150,200,0.7)]"></div>
                </div>
              </div>
              
              <!-- Dark Overlay at Bottom -->
              <div 
                class="absolute bottom-0 left-0 right-0 h-[44px]"
                style="background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 10%, rgba(0, 0, 0, 0.8) 60%, rgba(0, 0, 0, 0) 100%);">
              </div>
              
              <!-- Checkmark Icon (shown when selected) -->
              <div
                *ngIf="isActivitySelected(activity.id)"
                class="absolute top-[8px] right-[8px] gap-[8px] flex flex-row w-[24px] h-[24px] shrink-0 rounded-[100px] justify-center items-center bg-[#4caf50ff] border-[1px] border-white z-[2] shadow-[0_4px_10px_rgba(76,175,80,0.25)]">
                <img
                  src="assets/icons/check.svg"
                  alt="Selected activity checkmark"
                  loading="lazy"
                  decoding="async"
                  class="w-[20px] h-[20px] shrink-0 justify-start items-start" />
              </div>
              
              <!-- Unselected Indicator (shown when not selected) -->
              <div
                *ngIf="!isActivitySelected(activity.id)"
                class="absolute top-[8px] right-[8px] gap-[8px] flex flex-row w-[24px] h-[24px] shrink-0 rounded-[100px] justify-center items-center bg-white border-[1px] border-[#E5E7EB] z-[2]">
              </div>
              
              <!-- Activity Name - Overlaid on Image -->
              <div class="absolute bottom-0 left-0 right-0 h-[44px] flex flex-col justify-center items-center pl-[16px] pr-[16px] z-[1]">
                <span class="w-[100%] shrink-0 justify-start items-start self-stretch text-white text-center font-bold font-['archivo'] text-[18px] leading-[20px]">
                  {{ activity.name }}
                </span>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Buttons -->
    <div class="gap-[8px] flex flex-row w-[100%] shrink-0 justify-between items-start self-stretch">
      <NiButton
        variant="outlined"
        color="secondary"
        size="[20px]"
        label="Back"
        leadingIcon="arrowNarrowLeft"
        [px]="'[24px]'"
        [py]="'[16px]'"
        [rounded]="'[999px]'"
        border="1"
        borderColor="[#5BA5F5]"
        bg="transparent"
        (onClick)="onBackClick()"
        [styleClass]="
          'flex flex-row items-center gap-[8px] rounded-[999px] border border-[#5BA5F5] text-[#2E90FA] font-bold font-[' +
          `'archivo'] text-[18px] leading-[23px] line-height-[24px]'`">
      </NiButton>
      <div class="gap-[28px] flex flex-row shrink-0 justify-end items-center">
        <NiButton
          variant="outlined"
          color="primary"
          size="[20px]"
          label="Skip"
          [px]="'[24px]'"
          [py]="'[16px]'"
          [rounded]="'[999px]'"
          border="1"
          borderColor="[#00ABC8]"
          bg="transparent"
          (onClick)="onSkipClick()"
          textColor="[#00ABC8]"
          [styleClass]="
            'flex flex-row items-center gap-[8px] rounded-[999px] border border-[#5BA5F5] text-[#2E90FA] font-bold font-[' +
            `'archivo'] text-[18px] leading-[23px] line-height-[24px]'`">
        </NiButton>
        <NiButton
          variant="contained"
          color="primary"
          size="[20px]"
          [label]="isSaving ? 'Saving...' : 'Save'"
          [px]="'[24px]'"
          [py]="'[16px]'"
          [rounded]="'[999px]'"
          bg="[#f26f24ff]"
          textColor="#ffffff"
          [disabled]="!canSaveActivities"
          (onClick)="onSaveClick()"
          [styleClass]="
            'flex flex-row items-center gap-[12px] rounded-[999px] bg-[#f26f24ff] text-[#ffffffff] font-bold font-[' +
            `'archivo'] text-[18px] leading-[23px] px-[32px] py-[12px]` +
            (!canSaveActivities ? ' opacity-70 cursor-not-allowed' : '')">
        </NiButton>
      </div>
    </div>
  </div>

  <!-- Toaster Alert -->

</div>


  <NiAlert
    *ngIf="toasterMessage"
    [message]="toasterMessage"
    [variant]="toasterVariant"
    [position]="'top-right'"
    [dismissible]="true"
    [duration]="4000"
    (onClose)="dismissToaster()">
  </NiAlert>
